import {createSlice, type PayloadAction} from "@reduxjs/toolkit";
import type {DaoCategory} from "../daos/dao-category.ts";
import type {AppThunk} from "./index.ts";


export type ModalBottomStateType = 'category' | null;
export type ModalBottomStateData = DaoCategory | null;

export interface ModalBottomState {
  isOpen: boolean;
  type: ModalBottomStateType;
  data: ModalBottomStateData;
}

const initialState: ModalBottomState = {
  isOpen: false,
  type: null,
  data: null
};

const modalBottomSlice = createSlice({
  name: 'modalbottom',
  initialState,
  reducers: {
    // 다이얼로그를 여는 액션 (type, current)
    openModalBottom: (state: any, action: PayloadAction<Omit<ModalBottomState, 'isOpen'>>) => {
      state.isOpen = true;
      state.type = action.payload.type;
      state.data = action.payload.data;
    },
    // 다이얼로그를 닫는 액션
    closeModalBottom: (state: any) => {
      state.isOpen = false;
    },
  },
});

export const { openModalBottom, closeModalBottom } = modalBottomSlice.actions;
export default modalBottomSlice.reducer;


export const askModalBottom = (type: ModalBottomStateType, data: ModalBottomStateData): AppThunk<Promise<void>> =>
  async (dispatch: any) => {
    dispatch(openModalBottom({ type, data }));

    return new Promise<void>(() => {

    });
  };
